import React from "react";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import classNames from "classnames";
import { useI18n } from "i18n";
import { ISsoStatus } from "./SsoConfiguration";
import { useStyles } from "./StatusBadgeStyles";

interface IStatusBadgeProps {
  status: ISsoStatus;
}

const StatusBadge = ({ status }: IStatusBadgeProps) => {
  const { t } = useI18n(["sso"]);
  const classes = useStyles();
  const statusText = React.useMemo(() => {
    switch (status) {
      case ISsoStatus.ACTIVE:
        return t("sso:badge.active");
      case ISsoStatus.PENDING:
        return t("sso:badge.pending");
      case ISsoStatus.INACTIVE:
      default:
        return t("sso:badge.not.active");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <Typography
      variant="body1"
      className={classNames(classes.statusBadge, classes[status])}
      data-testid="status-badge"
    >
      {statusText}
    </Typography>
  );
};

export default StatusBadge;
